import { render, staticRenderFns } from "./HotelHero.vue?vue&type=template&id=136cdc7d&scoped=true&"
import script from "./HotelHero.vue?vue&type=script&lang=js&"
export * from "./HotelHero.vue?vue&type=script&lang=js&"
import style0 from "./HotelHero.vue?vue&type=style&index=0&id=136cdc7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136cdc7d",
  null
  
)

export default component.exports